module.exports = __webpack_public_path__ + "static/media/rate.d7be9e56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/ssp2/rate.svg
// module id = 494
// module chunks = 0